import React from "react";

export default ({ children }) => (<div className="StickyTop">{children}</div>)